<template>
    <v-dialog
            scrollable
            v-model="show"
            max-width="600px"
    >
        <v-card>
            <v-toolbar color="blue" flat dense dark>
                <v-toolbar-title class="body-1">{{title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small icon @click="close"><v-icon small>mdi-close</v-icon></v-btn>
            </v-toolbar>

            <v-card-text class="pa-0">
                <code-view :code="code" :lang="lang"></code-view>
            </v-card-text>

            <v-card-actions class="pa-0">
                <v-btn fab
                       absolute
                       class="custom-fab-position" color="blue" dark
                       @click="copyToClipboard">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
            </v-card-actions>

        </v-card>

    </v-dialog>
</template>

<script>
    import CodeView from "./CodeView";
    import {NOTIFICATION_NS} from "@/store/modules/notification/constants";
    import {mapActions} from "vuex";

    export default {
        name: "ReceiptDialog",
        components: {CodeView},
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },
        props: [
            /*v-model value for show/hide of the dialog*/
            'value',
            'title',
            /*code to display*/
            'code',
            /*code language (for highlighting*/
            'lang'
        ],
        methods: {
            ...mapActions(NOTIFICATION_NS, [
                'addNotification'
            ]),
            close() {
                this.show = false;
            },
            copyToClipboard() {
                navigator.clipboard.writeText(this.code);
                this.addNotification({
                    message: 'Content copied to clipboard!'
                });
            }
        }
    }
</script>

<style scoped>
    .custom-fab-position {
        bottom: 1.2em;
        right: 1.2em
    }
</style>